import { Button } from "@/components/ui/button";
import { ChefHat, Clock, LogOut, RefreshCw } from "lucide-react";

const PortalPendingScreen = ({ account, onRefresh, onLogout }) => (
  <div className="min-h-screen bg-background" data-testid="portal-pending-screen">
    <header className="border-b border-border bg-card/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-2">
            <ChefHat className="w-5 h-5 text-primary" />
            <span className="font-semibold">{account.restaurant_name}</span>
          </div>
          <Button variant="ghost" size="sm" onClick={onLogout} className="text-muted-foreground">
            <LogOut className="w-4 h-4 mr-2" />Abmelden
          </Button>
        </div>
      </div>
    </header>
    <main className="max-w-md mx-auto px-4 py-20 text-center">
      <Clock className="w-14 h-14 text-primary mx-auto mb-6" />
      <h1 className="text-2xl font-bold mb-3">Freischaltung ausstehend</h1>
      <p className="text-muted-foreground mb-2">
        Vielen Dank für Ihre Registrierung, <span className="font-medium text-foreground">{account.restaurant_name}</span>!
      </p>
      <p className="text-xs text-muted-foreground mb-4" data-testid="pending-account-email">
        Angemeldet als: <span className="font-medium text-foreground">{account.email}</span>
      </p>
      <p className="text-sm text-muted-foreground mb-8">
        Ihr Konto wird derzeit vom Étoile-Team geprüft. Sobald es freigeschaltet ist,
        erhalten Sie Zugriff auf die Vorlieben Ihrer Gäste. Dies dient dem Schutz der Gästedaten.
      </p>
      <div className="flex flex-col gap-3 items-center">
        <Button
          variant="outline"
          onClick={onRefresh}
          className="border-border hover:border-primary hover:text-primary"
          data-testid="pending-refresh-button"
        >
          <RefreshCw className="w-4 h-4 mr-2" />
          Status aktualisieren
        </Button>
        <Button
          variant="ghost"
          onClick={onLogout}
          className="text-muted-foreground hover:text-primary"
          data-testid="pending-switch-account-button"
        >
          <LogOut className="w-4 h-4 mr-2" />
          Abmelden & mit anderem Konto anmelden
        </Button>
      </div>
    </main>
  </div>
);

export default PortalPendingScreen;
